import CommonMiddleware from 'yoda-site-components/lib/middlewares/CommonMiddleware';
import AccountComponentsMiddleware from 'yoda-account-components/lib/middlewares/AccountComponentsMiddleware';
import CommonCJAMiddleware from 'yoda-site-components/lib/middlewares/CommonCJAMiddleware';
import PostPurchaseAnalyticsMiddleware from './PostPurchaseAnalyticsMiddleware';

const rootMiddleware = [
    CommonMiddleware,
    CommonCJAMiddleware,
    PostPurchaseAnalyticsMiddleware,
    AccountComponentsMiddleware,
];

export default rootMiddleware;
